import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Switch, useSwitch } from '.';
import { wrap } from '@atlasgroup/react-wrap';
import { WrapperHorizontal, WrapperVertical } from '../../gatsby-theme-docz/components/Wrapper';
import { Icon } from '../Icon';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "switch"
    }}>{`Switch`}</h1>
    <p>{`Is a component that allows the user to toggle between two states.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<WrapperVertical>\n  <Switch />\n  <Switch isChecked />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Switch,
      useSwitch,
      wrap,
      WrapperHorizontal,
      WrapperVertical,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Switch mdxType="Switch" />
        <Switch isChecked mdxType="Switch" />
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "types"
    }}>{`Types`}</h2>
    <Playground __position={1} __code={'<WrapperVertical>\n  <Switch type=\"default\" isChecked />\n  <Switch type=\"primary\" isChecked />\n  <Switch type=\"info\" isChecked />\n  <Switch type=\"success\" isChecked />\n  <Switch type=\"warning\" isChecked />\n  <Switch type=\"error\" isChecked />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Switch,
      useSwitch,
      wrap,
      WrapperHorizontal,
      WrapperVertical,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Switch type="default" isChecked mdxType="Switch" />
        <Switch type="primary" isChecked mdxType="Switch" />
        <Switch type="info" isChecked mdxType="Switch" />
        <Switch type="success" isChecked mdxType="Switch" />
        <Switch type="warning" isChecked mdxType="Switch" />
        <Switch type="error" isChecked mdxType="Switch" />
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "other-props"
    }}>{`Other props`}</h2>
    <h3 {...{
      "id": "on--off-content"
    }}>{`On & Off content`}</h3>
    <Playground __position={2} __code={'<WrapperVertical>\n  <Switch textOn=\"On\" isChecked />\n  <Switch textOff=\"Off\" isChecked={false} />\n  <Switch textOn={<Icon name=\"check\" />} isChecked />\n  <Switch textOff={<Icon name=\"close\" />} isChecked={false} />\n  <Switch textOn=\"On\" textOff=\"Off\" isPartiallyChecked />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Switch,
      useSwitch,
      wrap,
      WrapperHorizontal,
      WrapperVertical,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Switch textOn="On" isChecked mdxType="Switch" />
        <Switch textOff="Off" isChecked={false} mdxType="Switch" />
        <Switch textOn={<Icon name="check" mdxType="Icon" />} isChecked mdxType="Switch" />
        <Switch textOff={<Icon name="close" mdxType="Icon" />} isChecked={false} mdxType="Switch" />
        <Switch textOn="On" textOff="Off" isPartiallyChecked mdxType="Switch" />
    </WrapperVertical>
    </Playground>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <Playground __position={3} __code={'<Switch description=\"Text\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Switch,
      useSwitch,
      wrap,
      WrapperHorizontal,
      WrapperVertical,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Switch description="Text" mdxType="Switch" />
    </Playground>
    <h2 {...{
      "id": "isdisabled"
    }}>{`isDisabled`}</h2>
    <Playground __position={4} __code={'<WrapperVertical>\n  <Switch isChecked isDisabled />\n  <Switch isChecked={false} isDisabled />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Switch,
      useSwitch,
      wrap,
      WrapperHorizontal,
      WrapperVertical,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Switch isChecked isDisabled mdxType="Switch" />
        <Switch isChecked={false} isDisabled mdxType="Switch" />
    </WrapperVertical>
    </Playground>
    <h3 {...{
      "id": "ispartiallychecked-state"
    }}>{`isPartiallyChecked state`}</h3>
    <p>{`Represent that multiple sub-options are selected in the list.`}</p>
    <Playground __position={5} __code={'<WrapperVertical>\n  <Switch isChecked={false} isPartiallyChecked />\n  <Switch isChecked isPartiallyChecked />\n  <Switch isChecked={false} isPartiallyChecked={false} />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Switch,
      useSwitch,
      wrap,
      WrapperHorizontal,
      WrapperVertical,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Switch isChecked={false} isPartiallyChecked mdxType="Switch" />
        <Switch isChecked isPartiallyChecked mdxType="Switch" />
        <Switch isChecked={false} isPartiallyChecked={false} mdxType="Switch" />
    </WrapperVertical>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      